
import { Dialog } from '../../../components/ui/dialog';
import { Button } from '../../../components/ui/button';
import { useTranslation } from 'react-i18next';

const DeleteBoardModel = ({ boardName, onConfirm, onCancel, isOpen }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onCancel}
      title={t('app:crm.t43')} // «Are you sure you want to delete board»
      subtitle={`"${boardName}"?`}
    >
      {/* "Cancel" and "Delete" buttons */}
      <div className="mt-4 flex justify-end space-x-2">
        <Button
          onClick={onCancel}
          variant="outline" size="sm"
        >
          {t('app:crm.t5')} {/* «Cancel» */}
        </Button>
        <Button
          onClick={onConfirm} size="sm"
        >
          {t('app:crm.t44')} {/* «Delete» */}
        </Button>
      </div>
    </Dialog>
  );
};

export default DeleteBoardModel;
